import React, { useMemo } from "react";

import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";

import { formatValuta } from "../../../../utils";
import TranslationWrapper from "../../../../components/TranslationWrapper/TranslationWrapper";

function ArtikelTable({ ...props }) {
  const optionStyle = {
    display: "table",
    backgroundColor: "#ed916d",
    borderRadius: "5px",
    marginRight: "5px",
    marginBottom: "2px",
    fontSize: "12px",
    padding: "2px",
    minWidth: "0px",
    fontWeight: "bold",
    paddingLeft: "8px",
    paddingRight: "8px",
  };

  const totalPrice = useMemo(() => {
    return props.items.reduce((total, item) => {
      const itemTotal = item.aantal * item.totaal;
      return total + itemTotal;
    }, 0);
  }, [props.items]);

  return (
    <div>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <TranslationWrapper tDefault={"Naam"} tKey={"bestellingen.modal.detail.artikeltable.naam"} />
            </TableCell>
            <TableCell>
              <TranslationWrapper tDefault={"Prijs"} tKey={"bestellingen.modal.detail.artikeltable.prijs"} />
            </TableCell>
            <TableCell>
              <TranslationWrapper tDefault={"Aantal"} tKey={"bestellingen.modal.detail.artikeltable.aantal"} />
            </TableCell>
            <TableCell>
              <TranslationWrapper tDefault={"Totaal"} tKey={"bestellingen.modal.detail.artikeltable.totaal"} />
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.items
            ? props.items.map((prop, key) => {
                let productInfo = JSON.parse(prop.product);
                let defaultVat = productInfo.vatPercentage;
                let productOpties =
                  productInfo.pk !== null
                    ? productInfo.pk.map((option, optionKey) => {
                        let optionData = JSON.parse(option);
                        return (
                          <div key={"options" + optionKey} style={optionStyle}>
                            {optionData?.id ? optionData?.id + "-" : ""} {optionData.naam}{" "}
                            {optionData.prijs !== undefined && optionData.prijs != 0
                              ? "(" +
                                formatValuta(optionData.prijs, props.valuta) +
                                ", " +
                                +(optionData.vatPercentage ?? defaultVat) +
                                "%)"
                              : ""}
                          </div>
                        );
                      })
                    : null;

                return (
                  <TableRow key={key}>
                    <TableCell>
                      {productInfo.id} - {productInfo.naam}{" "}
                      {productInfo.prijs !== undefined && productInfo.prijs != 0
                        ? "(" + formatValuta(productInfo.prijs, props.valuta) + ", " + defaultVat + "%)"
                        : ""}
                      {productOpties}
                    </TableCell>
                    <TableCell>{formatValuta(prop.totaal, props.valuta)}</TableCell>
                    <TableCell>{prop.aantal}</TableCell>
                    <TableCell>{formatValuta(prop.aantal * prop.totaal, props.valuta)}</TableCell>
                  </TableRow>
                );
              })
            : null}
          <TableRow>
            <TableCell colSpan={3} style={{ fontWeight: "bold" }}>
              <TranslationWrapper tDefault={"Totaal"} tKey={"bestellingen.modal.detail.artikeltable.totaal"} />
            </TableCell>
            <TableCell style={{ fontWeight: "bold" }}>{formatValuta(totalPrice, props.valuta)}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
  );
}

export default ArtikelTable;
